import { gql } from '@apollo/client'

export const AllTags = gql`
    query AllTags($roomId: ID) {
        allTags(roomId: $roomId) {
            tag
            count
        }
    }
`

export default AllTags

